define('prototypes/PageFactory',[
        'underscore',
        'hooks',
        'PageView',
        'views/pages/AccountPageView',
        'views/pages/AuthentificationPageView',
        'views/pages/ListingPageView',
        'views/pages/HomePageView',
        'views/pages/WidgetPageView',
        'views/pages/ProductPageView',
        'views/pages/CheckoutOpcPageView',
        'views/pages/CheckoutConfirmationPageView',
        'views/pages/CheckoutPendingPageView',
        'views/pages/StoreLocatorPageView',
        'views/pages/GuiPageView',
        'views/pages/SocialWallPageView',
        'views/pages/SupportCenterPageView',
        'views/pages/ReorderPageView',
        'views/pages/NotFoundPageView',
        'views/pages/ContactPageView',
        'views/pages/OtherCountryPageView',
        'views/pages/AccountLinkPageView',
        'views/pages/SensoryTripPageView',
        'views/pages/NewsPageView',
        'views/pages/FidelityPageView'
    ],function (
        _,
        hooks,
        PageView,
        AccountPageView,
        AuthentificationPageView,
        ListingPageView,
        HomePageView,
        WidgetPageView,
        ProductPageView,
        CheckoutOpcPageView,
        CheckoutConfirmationPageView,
        CheckoutPendingPageView,
        StoreLocatorPageView,
        GuiPageView,
        SocialWallPageView,
        SupportCenterPageView,
        ReorderPageView,
        NotFoundPageView,
        ContactPageView,
        OtherCountryPageView,
        AccountLinkPageView,
        SensoryTripPageView,
        NewsPageView,
        FidelityPageView
)
{
    //
    // PageView Factory
    //

    //
    // liste l’ensemble des vue des pages
    //
    return function(pageName){

        var views = {
            Account:AccountPageView,
            Authentification:AuthentificationPageView,
            Listing:ListingPageView,
            Category:ListingPageView,
            Home:HomePageView,
            Widget:WidgetPageView,
            Product:ProductPageView,
            gui:GuiPageView,
            CheckoutOpc:CheckoutOpcPageView,
            CheckoutConfirmation:CheckoutConfirmationPageView,
            CheckoutPending:CheckoutPendingPageView,
            Store:StoreLocatorPageView,
            SocialWall:SocialWallPageView,
            Reorder:ReorderPageView,
            SupportCenter:SupportCenterPageView,
            Widget:WidgetPageView,
            NotFound:NotFoundPageView,
            Contact :ContactPageView,
            OtherCountry:OtherCountryPageView,
            AccountLink:AccountLinkPageView,
            SensoryTrip:SensoryTripPageView,
            News:NewsPageView,
            fidelity:FidelityPageView
        };

        var pageView = views[pageName];

        hooks.execHook('PageFactory',pageName,function(hookPageView){
            pageView = hookPageView;
        })

        // si l'identifiant est inconnue,
        // on utilise le prototype par défaut
        if(_.isUndefined(pageView)){
            pageView = PageView;
        }

        return pageView;
    }
});
